<script>
import ConfKeyExtends from './SourceConfKeys.vue'
import nodeID from '@/mixins/nodeID'
import { deleteSinkConfKey } from '@/api/metadata'
import { RESOURCE_TYPE } from '@/utils/constants'

export default {
  name: 'SinkConfKey',
  extends: ConfKeyExtends,
  mixins: [nodeID],

  data() {
    return {
      category: RESOURCE_TYPE.sinks,
    }
  },

  computed: {
    modalTitle() {
      return !this.isEditConfKey ? this.$t('configuration.addSinkTemplate') : this.$t('configuration.editSinkTemplate')
    },
  },

  methods: {
    removeConfKey(row) {
      const { name, type } = row
      deleteSinkConfKey(this.nodeID, type, name).then(() => {
        this.$emit('reload')
      })
    },
  },
}
</script>
